module.exports = __webpack_public_path__ + "static/media/confirm.95907a33.svg";